import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import classNames from "@workspace/casino_pages/legacyLayer/external/classNames";
import getThemeClassName from "@workspace/casino_pages/legacyLayer/shared/utils/getThemeClassName";
import ActionButton from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/KycNotification/ActionButton";
import getKycNotificationContent from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/KycNotification/helpers/getKycNotificationContent";

const KycNotification: FC<NotificationViewProps> = ({
  notification,
  onClose,
  context,
}) => {
  const { name = "" } = notification.data || {};
  const { icon, text, action } = getKycNotificationContent(name);
  const isDeclined = name === "kyc_failed";
  const isSuccess = name === "kyc_processing" || name === "kyc_accepted";
  const declineReasons =
    notification.data?.verificationProcess?.declineReasons || [];

  return (
    <div
      data-testid={`kyc-notification-${name}`}
      className={classNames(
        "grid cursor-pointer gap-4 rounded-lg border border-solid border-border bg-secondary p-4 shadow-lg ltr:text-left rtl:text-right",
        getThemeClassName(context.site, "light"),
      )}
    >
      <div className="grid grid-flow-col grid-cols-[1fr_auto] items-center gap-3">
        <div
          className={classNames(
            "grid grid-flow-col grid-cols-[auto_1fr] items-center gap-3",
            isDeclined && "items-start",
          )}
        >
          <div
            className={classNames(
              "flex h-10 w-10 items-center justify-center rounded-lg bg-caution/8",
              isDeclined && "bg-destructive/8",
              isSuccess && "bg-positive/8",
            )}
          >
            {icon}
          </div>
          <div className="grid">
            <p
              className={classNames(
                "text-sm/6 text-foreground",
                isDeclined && "text-destructive",
              )}
            >
              <Translation
                translations={context.translations}
                id={`notifications.kyc.${text}`}
              />
            </p>
            {isDeclined && (
              <ul className="pl-5">
                {declineReasons.map((declineReason: string) => (
                  <li key={declineReason}>
                    <p className="text-xs">
                      <Translation
                        translations={context.translations}
                        id={`kyc.decline_reasons.${declineReason}`}
                      />
                    </p>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <ActionButton
          notification={notification.data}
          action={action}
          onClose={onClose}
          translations={context.translations}
          context={context}
        />
      </div>
    </div>
  );
};

export default KycNotification;
